import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";

import {
  POST_GetCommunicationLogList,
  GET_GetCommunicationLogTypes,
  POST_GetCommunicationLogExport,
} from "../../../helpers/url_helper";
import { get, post } from "../../../helpers/api_helper";
import moment from "moment";
import { errorMessage } from "../CommonFunctions";

const CommunicationLog = () => {
  const [isLoading, setIsLoading] = useState(false);
  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(true);
  const navigate = useNavigate();
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const [communicationList, setCommunicationList] = useState([]);
  const [tranTypes, setTranTypes] = useState([]);
  const [isReset, setIsReset] = useState(false);

  const typeOptions = [
    { label: "All", value: 0 },
    { label: "Email", value: 1 },
    { label: "WhatsApp", value: 2 },
  ];

  const formikFilter = useFormik({
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),

    initialValues: {
      FromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      ToDate: new Date(),
      CommunicationType: AuthUser?.Permissions?.Whatsup == 0 ? 1 : 0,
      TranType: 0,
      Search: "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmit,
    values: {
      Search,
      FromDate,
      CommunicationType,
      TranType,
      ToDate,
      SearchText,
    },
  } = formikFilter;

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    getCommunicationLogTypes();
    getData(1, currentSizePerPage);
  }, []);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  const getCommunicationLogTypes = async () => {
    setIsLoading(true);
    await get(GET_GetCommunicationLogTypes)
      .then((response) => {
        if (response?.IsSuccess) {
          const tranTypes = [
            { label: "All", value: 0 },
            ...response?.List?.map((item) => ({
              label: item.Name,
              value: item.TranType,
            })),
          ];

          // if (AuthUser?.Permissions?.UploadScanCopy !== 1) {
          //   tranTypes = tranTypes.filter(
          //     (t) => t.label !== "Scan Copy Upload" //2- hide from dropdown
          //   );
          // }

          // // ✅ Filter Dispatch Report based on permission
          // if (AuthUser?.Permissions?.DispatchReport !== 1) {
          //   tranTypes = tranTypes.filter(
          //     (t) => t.label !== "Dispatch Report" //3- hide from dropdown
          //   );
          // }

          // if (AuthUser?.Permissions?.DispatchMaterial !== 1) {
          //   tranTypes = tranTypes.filter(
          //     (t) => t.label !== "Dispatch Material" //4- hide from dropdown
          //   );
          // }
          // if (AuthUser?.Permissions?.Account !== 1) {
          //   const hideLabels = [
          //     "Performa Invoice", // 5
          //     "Invoice", // 6
          //     "Advance Receipt", // 7
          //     "Payment Receipt", // 8
          //     "Credit Note", // 9
          //     "Outstanding", // 10
          //   ];

          //   tranTypes = tranTypes.filter((t) => !hideLabels.includes(t.label));
          // }

          // if (AuthUser?.Permissions?.MachineMaintenance !== 1) {
          //   const hideLabels = [
          //     "Machine Calibration Validity Expire", // 15
          //     "Machine Certificate", // 16
          //   ];

          //   tranTypes = tranTypes.filter((t) => !hideLabels.includes(t.label));
          // }

          // collect blocked IDs
          let blockedIds = [];

          if (AuthUser?.Permissions?.UploadScanCopy !== 1) {
            blockedIds.push(2); // Scan Copy Upload
          }

          if (AuthUser?.Permissions?.DispatchReport !== 1) {
            blockedIds.push(3); // Dispatch Report
          }

          if (AuthUser?.Permissions?.DispatchMaterial !== 1) {
            blockedIds.push(4); // Dispatch Material
          }

          if (AuthUser?.Permissions?.Account !== 1) {
            blockedIds.push(
              5, // Performa Invoice
              6, // Invoice
              7, // Advance Receipt
              8, // Payment Receipt
              9, // Credit Note
              10, // Outstanding
            );
          }

          if (AuthUser?.Permissions?.MachineMaintenance !== 1) {
            blockedIds.push(
              15, // Machine Calibration Validity Expire
              16, // Machine Certificate
            );
          }

          // final filter by ID
          if (blockedIds.length > 0) {
            tranTypes = tranTypes.filter((t) => !blockedIds.includes(t.value));
          }

          setTranTypes(tranTypes);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);
    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: Search,
      Sorting: "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CommunicationType: CommunicationType,
      TranType: TranType,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
    };
    await post(POST_GetCommunicationLogList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setCommunicationList(response?.List);
        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const exportReport = () => {
    setIsLoading(true);
    let playload = {
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      SearchText: SearchText,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CommunicationType: CommunicationType,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      TranType: TranType,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    post(POST_GetCommunicationLogExport, playload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getResetData = async () => {
    setIsLoading(true);
    formikFilter.setValues({
      FromDate: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      ToDate: new Date(),
      TranType: 0,
      CommunicationType: 0,
      Search: "",
    });
    setCurrentPage(1);
    setIsReset(true);
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="table-responsive active-projects style-1 shorting">
            <div className="tbl-caption p-2">
              <h4 className="heading mb-0">Communication Log</h4>
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  title="Go to Reports"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa-solid fa-table" /> Back to Report Menu
                </button>
                <button
                  type="button"
                  title="Reset"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={(e) => {
                    getResetData();
                  }}
                >
                  <i className="fa fa-window-restore" aria-hidden="true"></i>{" "}
                  Reset
                </button>

                <button
                  type="button"
                  title="Filter"
                  className="btn btn-outline-primary btn-sm me-2"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  <i className="fa-solid fa-filter me-2"></i>Filter
                </button>
                <Link
                  title="Export Report"
                  className="btn btn-outline-primary btn-sm"
                  onClick={exportReport}
                >
                  <i className="fa-solid fa-file-excel" /> Export Report
                </Link>
              </div>
            </div>
            <hr className="mt-0 mb-1"></hr>
            <div className="p-2 pt-0 pb-0">
              {showFilter ? (
                <div>
                  <FormikProvider value={formikFilter}>
                    <Form onSubmit={formikFilter.handleSubmit}>
                      <Row className="me-0">
                        <Col lg={2}>
                          <Field
                            label="Search"
                            name="Search"
                            placeholder={"Search here..."}
                            component={CustomInput}
                            autoFocus={isFilterExpanded}
                          />
                        </Col>

                        {AuthUser?.Permissions?.Whatsup == 1 && (
                          <Col lg={2}>
                            <Field
                              label=" Type"
                              name="CommunicationType"
                              placeholder="Select Type"
                              component={CustomSelect}
                              options={typeOptions}
                              menuPosition="fixed"
                              isClearable={false}
                            />
                          </Col>
                        )}

                        <Col lg={2}>
                          <Field
                            label="Transaction Type"
                            name="TranType"
                            placeholder="Select Transaction Type"
                            component={CustomSelect}
                            options={tranTypes} // Dynamic options from API
                            menuPosition="fixed"
                            isClearable={false}
                          />
                        </Col>
                        <Col lg={3}>
                          {/* <label className="mb-1"></label> */}
                          <div className="d-flex">
                            <Field
                              label="From Date"
                              name="FromDate"
                              placeholder={"From Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                              }}
                            />
                            <div>&nbsp;</div>
                            <Field
                              label="To Date"
                              name="ToDate"
                              placeholder={"To Date"}
                              component={CustomFlatpickr}
                              options={{
                                altInput: true,
                                altFormat: "j-M-Y",
                                dateFormat: "d-m-Y",
                                minDate: FromDate,
                              }}
                            />
                          </div>
                        </Col>

                        <Col lg={2}>
                          <label className="mb-1">&nbsp;</label>
                          <div className="d-flex">
                            <div className="d-lg-block">
                              <Link
                                className="btn btn-primary btn-sm mb-1"
                                onClick={(e) => {
                                  getData();
                                }}
                              >
                                <i
                                  className="fa fa-Search"
                                  aria-hidden="true"
                                ></i>
                                {"  "} Search
                              </Link>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </FormikProvider>
                </div>
              ) : (
                ""
              )}

              <div
                id="ChatHistory-tbl_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="ChatHistory-tbl"
                  className="table dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th style={{ width: "30px" }}>Sr No</th>
                      <th style={{ width: "100px" }}> Type</th>
                      <th style={{ width: "150px" }}> Transaction Type</th>
                      <th style={{ width: "120px" }}>Transaction No</th>
                      <th style={{ width: "180px" }}>Sender</th>
                      <th style={{ width: "180px" }}>Receiver</th>
                      <th style={{ width: "100px", textAlign: "left" }}>
                        Send Date
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {communicationList.length > 0 ? (
                      communicationList.map((item, indx) => (
                        <tr key={indx}>
                          <td
                            style={{
                              textAlign: "center",
                              verticalAlign: "top",
                            }}
                          >
                            {item?.RowNo}
                          </td>
                          <td
                            style={{
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item?.CommunicationType}
                          </td>
                          <td
                            style={{
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item?.TranTypeName}
                          </td>
                          <td
                            style={{
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item?.TranNo}
                          </td>
                          <td
                            style={{
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item?.SenderName}
                          </td>
                          <td
                            style={{
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item?.ReceiverName}
                          </td>
                          <td
                            style={{
                              textAlign: "left",
                              whiteSpace: "normal",
                              verticalAlign: "top",
                            }}
                          >
                            {item?.SendDate}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9} style={{ textAlign: "left" }}>
                          <div>{"No Record Found..."}</div>{" "}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="d-sm-flex text-center justify-content-between align-items-center mt-2">
                  <CustomSizePerPage
                    getData={getData}
                    currentSizePerPage={currentSizePerPage}
                  />
                  <div className="dataTables_info">
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <CustomPaginationButtons
                    totalPages={recordCount / currentSizePerPage}
                    currentPage={currentPage}
                    currentSizePerPage={currentSizePerPage}
                    getData={getData}
                  />
                </div>
              </div>
            </div>
          </div>
        </Spin>
      </div>
    </div>
  );
};
export default CommunicationLog;
